// external
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

// store
import { GET_LOADING_PROMOTIONS, GET_PROMOTIONS } from '@/store/types';

// models
import { PromotionCarouselItem } from '../../interfaces/PromotionCarouselItem';

// conponents
import PromotionCarousel from './components/promotion-carousel/PromotionCarousel.vue';

@Component({
    components: {
        PromotionCarousel,
    },
})
export default class Promotions extends Vue {
    @Getter(GET_PROMOTIONS) promotions!: PromotionCarouselItem[];

    @Getter(GET_LOADING_PROMOTIONS) getLoadingPromotions!: boolean;

    @Watch('getLoadingPromotions')
    onLoadingUpdated(nv: boolean) {
        if (nv === false) {
            this.$nextTick(() => this.$forceUpdate());
        }
    }
}
